const $d7fcaaa29d0ffaa7$var$url = `http://46.101.204.118:3000/random-word`;
const $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e = {
    loadedWord: [],
    player: {
        wordEntered: [],
        indexOfLetter: [],
        truePosition: [],
        win: false,
        guessNum: 0
    }
};
const $d7fcaaa29d0ffaa7$export$3e7b1d7d97b19b83 = async function() {
    try {
        const data = await fetch($d7fcaaa29d0ffaa7$var$url);
        //if (!data.ok || (!data)) throw new Error('reqquest is not vaild')
        // let word = (await data.json())[0];
        let word = await data.json();
        console.log(word);
        // if (!word) throw new Error("the word you looking for does not exist");
        const wordArr = word.word.split('');
        console.log(wordArr);
        $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.loadedWord = wordArr;
        console.log($d7fcaaa29d0ffaa7$export$ca000e230c0caa3e);
        return word;
    } catch (error) {
        console.log('server is down', error);
    }
};
const $d7fcaaa29d0ffaa7$export$35dc45686fc2dbd7 = function(wordEntered, wordToCompare) {
    try {
        $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.player.guessNum = $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.player.guessNum + 1;
        //checks the number of letters if its match
        if (wordEntered.length != wordToCompare.length) throw new Error('word size is not correct');
        //checks each letter
        $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.player.wordEntered = wordEntered;
        const resultArr = wordEntered.map((element)=>{
            if (wordToCompare.includes(element)) return true;
            else return false;
        });
        console.log('resuilt array', resultArr);
        $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.player.resultArr = resultArr;
        let indexOfLetter = resultArr.map((el, index)=>{
            if (el === true) return index;
        });
        $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.player.indexOfLetter = indexOfLetter;
        console.log(indexOfLetter);
        //check position of true letter
        let i = 0;
        while(i < wordToCompare.length){
            if (wordEntered[i] === wordToCompare[i]) {
                $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.player.truePosition.push(i);
                if ($d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.player.truePosition.length === wordToCompare.length) $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.player.win = true;
            }
            i++;
        }
    } catch (error) {
        console.log(error);
    }
} //check(['e','d','y'],['g','g','e'])
;


class $467972dd7b1d4dab$var$View {
    #parentEl = document.querySelector('.container');
    #row = document.querySelector('.row');
    #submitBtn = document.querySelector('#submit-btn');
    #btnBox = document.querySelectorAll('.btn-box');
    #input = document.querySelector('.input');
    #title = document.querySelector('#title');
    #guessNum = document.querySelector('#guess-num');
    #data;
    renderWord(data) {
        this.#data = data;
        let markup = '';
        this.#data.loadedWord.forEach((el, index)=>{
            markup = markup + this.generateMarkup(el, index);
        });
        this.#parentEl.insertAdjacentHTML('afterbegin', markup);
    }
    renderLetters(data) {
        let numOfBox = data.player.wordEntered.length;
        let markup = '';
        console.log(numOfBox);
        for(let index = 0; index < numOfBox; index++)markup = markup + this.generateMarkup(data.player.wordEntered[index], index);
        this.#parentEl.innerHTML = '';
        this.#parentEl.insertAdjacentHTML('afterbegin', markup);
        this.showCorrectLetters(data);
    }
    showCorrectLetters(data) {
        console.log(data);
        const btnBoxes = document.querySelectorAll('.btn-box');
        for(let index = 0; index < btnBoxes.length; index++){
            console.log(data.player.truePosition);
            if (btnBoxes[index].dataset.index == data.player.indexOfLetter[index]) {
                console.log(data.player.indexOfLetter[index], '<<<<');
                btnBoxes[index].classList.add('unplaced');
            }
            if (data.player.truePosition.length > 0) data.player.truePosition.forEach((el, elIndex)=>{
                if (el == btnBoxes[index].dataset.index) btnBoxes[index].classList.add('correct');
            });
        }
        if (data.player.win) this.#title.innerText = 'you won!';
    }
    updateGuess(data) {
        if (data.player.win) this.#title.innerText = `  \u{641}\u{632}\u{62A} \u{644}\u{642}\u{62F} \u{628}\u{640}\u{640}\u{640}\u{640}     ${data.player.guessNum} \u{645}\u{62D}\u{627}\u{648}\u{644}\u{627}\u{62A}     `;
        else {
            console.log('the guesses left : ', data.player.guessNum);
            this.#guessNum.innerText = data.player.guessNum;
        }
    }
    generateMarkup(letter, index) {
        const markup = `
        
                         <div class="btn-box " data-index=${index}  >
                         <button class="btn">${letter}</button>
                         </div>
        
                           `;
        return markup;
    }
    adEventHandler(cb) {
        this.#submitBtn.addEventListener('click', (ev)=>{
            const enteredWord = [
                ...this.#input.value
            ];
            cb(enteredWord);
        });
    }
}
var $467972dd7b1d4dab$export$2e2bcd8739ae039 = new $467972dd7b1d4dab$var$View;


const $d63a8266effe4d07$var$newBtn = document.querySelector('#new-btn');
const $d63a8266effe4d07$export$2cd8252107eb640b = async function() {
    // load from api
    await $d7fcaaa29d0ffaa7$export$3e7b1d7d97b19b83();
    // render the word
    (0, $467972dd7b1d4dab$export$2e2bcd8739ae039).renderWord({
        loadedWord: [
            'x',
            'x',
            'x',
            'x',
            'x'
        ]
    });
    // handler
    (0, $467972dd7b1d4dab$export$2e2bcd8739ae039).adEventHandler((enteredWord)=>{
        if ($d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.player.win) return;
        $d7fcaaa29d0ffaa7$export$35dc45686fc2dbd7(enteredWord, $d7fcaaa29d0ffaa7$export$ca000e230c0caa3e.loadedWord);
        (0, $467972dd7b1d4dab$export$2e2bcd8739ae039).renderLetters($d7fcaaa29d0ffaa7$export$ca000e230c0caa3e);
        (0, $467972dd7b1d4dab$export$2e2bcd8739ae039).updateGuess($d7fcaaa29d0ffaa7$export$ca000e230c0caa3e);
    });
    $d63a8266effe4d07$var$newBtn.addEventListener('click', ()=>{
        window.location.reload();
    });
};
var $d63a8266effe4d07$export$2e2bcd8739ae039 = $d63a8266effe4d07$export$2cd8252107eb640b;


window.addEventListener('load', (0, $d63a8266effe4d07$export$2e2bcd8739ae039));


//# sourceMappingURL=E1.a16af3cd.js.map
